var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatReviews = function SvgStatReviews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#A6A5A3",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "m9.248 13.225 1.543 1.198c.201.201.651.297.948.297h1.898c.594 0 1.246-.45 1.4-1.045l1.197-3.632c.25-.7-.201-1.293-.949-1.293h-1.993a.503.503 0 0 1-.498-.595l.249-1.59c.096-.45-.201-.95-.652-1.093-.402-.153-.9.048-1.092.345L9.257 8.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.708 13.225V8.347c0-.7.297-.949.997-.949h.498c.7 0 .997.25.997.95v4.877c0 .7-.297.949-.997.949h-.498c-.7 0-.997-.25-.997-.949Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.25 18.074h-.728c-.767 0-1.495.297-2.032.834l-1.639 1.62a1.938 1.938 0 0 1-2.712 0L8.5 18.908a2.88 2.88 0 0 0-2.031-.834H5.75c-1.59 0-2.875-1.274-2.875-2.846V4.772c0-1.571 1.284-2.846 2.875-2.846h11.5c1.59 0 2.875 1.275 2.875 2.846v10.456c0 1.562-1.284 2.846-2.875 2.846Z"
  })));
};
export default SvgStatReviews;